import { useContext, useEffect } from "react"
import { Box } from "@mui/material"
import { FeatureState } from "../global/GlobalFcn"
import { ToolContext } from "../../../../core/context/ToolContext"
// import { UsageAccess } from "./usageAccess/UsageAccess"
import { ActivePercentage } from "./activePercentage/ActivePercentage"
import { AwarePercentage } from "./awarePercentage/AwarePercentage"
import { UsagePercentage } from "./usagePercentage/UsagePercentage"
import { UsedPage } from "./usedPage/UsedPage"
import { GetToolUsage } from "../../../../core/request/Global"

export const UsageComponents = ({vldt, __SESSION, toolOwned, graphDatasets, interval}) => {

    const { usage_state } = useContext(ToolContext);
    const { toolUsageData } = usage_state

    // let res_target = [
    //     {"id":3,"series_num":"TTRSH-00000003","tool_id":14,"role_id":4,"active_user_threshold":12,
    //         "features":[
    //             {"id":33,"tool_feature_id":1,"tool_pages":1,"usage_threshold":2,"name":"dashboard"},
    //             {"id":32,"tool_feature_id":2,"tool_pages":2,"usage_threshold":3,"name":"bcloud"},
    //             {"id":34,"tool_feature_id":3,"tool_pages":3,"usage_threshold":12,"name":"policies"},
    //             {"id":20,"tool_feature_id":4,"tool_pages":2,"usage_threshold":3,"name":"general-maintenance"},
    //             {"id":21,"tool_feature_id":5,"tool_pages":1,"usage_threshold":2,"name":"hero"},
    //             {"id":22,"tool_feature_id":6,"tool_pages":3,"usage_threshold":1,"name":"tool-categories"},
    //             {"id":23,"tool_feature_id":7,"tool_pages":2,"usage_threshold":3,"name":"profile"}
    //         ]
    //     }
    // ]
    
    // {feature_id:1, feature_name:"dashboard", path:"1", value:63},
    // {feature_id:2, feature_name:"bcloud", path:"2", value:50},
    // {feature_id:3, feature_name:"policies", path:"3", value:50},
    // {feature_id:4, feature_name:"general-maintenance", path:"4", value:50},
    // {feature_id:5, feature_name:"hero", path:"5", value:50},
    // {feature_id:6, feature_name:"tool-categories", path:"6", value:50},
    // {feature_id:7, feature_name:"profile", path:"7", value:50},
    // let res_target = [
    //     {"id":3,"series_num":"TTRSH-00000003","tool_id":14,"role_id":4,"active_user_threshold":12,
    //         "features":[
    //             {"id":33,"tool_feature_id":29,"tool_pages":1,"usage_threshold":2,"name":"Market Place"},
    //             {"id":32,"tool_feature_id":32,"tool_pages":2,"usage_threshold":3,"name":"Business Tools"},
    //             {"id":34,"tool_feature_id":35,"tool_pages":3,"usage_threshold":12,"name":"Dashboard"},
    //             {"id":20,"tool_feature_id":41,"tool_pages":2,"usage_threshold":3,"name":"Referral"},
    //             {"id":21,"tool_feature_id":42,"tool_pages":1,"usage_threshold":2,"name":"My Profile"},
    //             {"id":22,"tool_feature_id":43,"tool_pages":3,"usage_threshold":1,"name":"Notification"},
    //             {"id":23,"tool_feature_id":44,"tool_pages":2,"usage_threshold":3,"name":"POFChat"},
    //             {"id":24,"tool_feature_id":45,"tool_pages":1,"usage_threshold":2,"name":"Get App (PWA)"},
    //             {"id":25,"tool_feature_id":46,"tool_pages":3,"usage_threshold":1,"name":"My Tools"},
    //             {"id":26,"tool_feature_id":47,"tool_pages":2,"usage_threshold":3,"name":"Updates"},
    //             {"id":27,"tool_feature_id":48,"tool_pages":1,"usage_threshold":2,"name":"Team Request"},
    //             {"id":28,"tool_feature_id":49,"tool_pages":3,"usage_threshold":1,"name":"Request"},
    //             {"id":29,"tool_feature_id":50,"tool_pages":2,"usage_threshold":3,"name":"Service Item"},
    //             {"id":30,"tool_feature_id":51,"tool_pages":1,"usage_threshold":2,"name":"Team Job Order"},
    //             {"id":31,"tool_feature_id":52,"tool_pages":3,"usage_threshold":1,"name":"Job Order"}
    //         ]
    //     }
    // ]

    const fetchToolUsageThreshold = async() => { 
        let qsp = {
            role_id:__SESSION.data.uaccess[0]?.role_id,
            tool_id:parseInt(process.env.REACT_APP_TID_BIZ),
            platform:'business'
        }
        console.log(qsp)
        let res_target = await GetToolUsage(qsp)
        console.log(res_target)
        if (res_target) {
            let role_type = __SESSION.data.uaccess[0]?.role_name
            let ftrdata = await FeatureState('all', role_type) || console.log('Feature Name is Not Found!')
            if (ftrdata) {
                let res_ftlr_data = ftrdata?.map(v => {return {feature_id:v.id, feature_name:v.feature_name, path:v.path } })
    
                const combineArray = res_ftlr_data?.map((rfd) => {
                    const rt = res_target[0]?.features.find((rt) => rfd.feature_id === rt.tool_feature_id && rfd.feature_name === rt.name); 
                    return {...rfd, usage_threshold:rt?.usage_threshold || 0, tool_pages:rt?.tool_pages || 0};
                });
    
                toolUsageData.set((prev) => ({...prev, 
                    active_threshold:res_target[0]?.active_user_threshold || 0,
                    feature_data:combineArray
                }))
            }
        }
    }

    useEffect(() => {
        fetchToolUsageThreshold()
        // eslint-disable-next-line
    }, [])
    
    return (
        <>
            {/* {vldt === '' && <UsageAccess __SESSION={__SESSION} toolOwned={toolOwned.data}/> } */}
            <Box display="flex" gap="24px" width="100%">
                <ActivePercentage __SESSION={__SESSION} graphDatasets={graphDatasets} interval={interval}/>
                <AwarePercentage __SESSION={__SESSION} graphDatasets={graphDatasets}/>
            </Box>
            <UsagePercentage __SESSION={__SESSION} graphDatasets={graphDatasets} interval={interval}/>
            <UsedPage __SESSION={__SESSION} graphDatasets={graphDatasets}/>
        </>
    )
}